import { TipRepository } from "../../../repositories/tipRepository"
import { UseCase } from "../../useCase"
import { UpdateCountryTipRequest } from "./request"
import { UpdateCountryTipResponse } from "./response"

export class UpdateCountryTipUseCase implements UseCase<UpdateCountryTipRequest, UpdateCountryTipResponse> {
	private _repository

	constructor({ TipRepository }: { TipRepository: TipRepository }) {
		this._repository = TipRepository
	}

	exec({ tipId, countryId, position }: UpdateCountryTipRequest) {
		return this._repository.updateCountryTip(tipId, countryId, position)
	}
}
